import { render, staticRenderFns } from "./waitting.vue?vue&type=template&id=40982bbb&scoped=true&"
import script from "./waitting.vue?vue&type=script&lang=js&"
export * from "./waitting.vue?vue&type=script&lang=js&"
import style0 from "./waitting.vue?vue&type=style&index=0&id=40982bbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40982bbb",
  null
  
)

export default component.exports